module.exports = __webpack_public_path__ + "img/huawei.c9f5f79b.png";